import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    phrasesSelectorChangeRefinePhrase,
    phrasesSelectorGetPhraseStats,
    phrasesSelectorGetRefineWords,
    phrasesSelectorSetPhraseInfo
} from '../../actions/phrases-selector/refinements';
import {
    PhrasesSelectorRefinePhrase,
    PhrasesSelectorRefinePhraseProps
} from '../../components/PhrasesSelector/PhrasesSelectorRefinePhrase/PhrasesSelectorRefinePhrase';
import { selectPhrasesSelectorWizard } from '../../selectors/phrasesSelector/phrasesSelector';
import { PhrasesSelectorPhrase, PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    wizardId: PhrasesSelectorWizardId;
    keyword: string;
    shows: number;
    onCancel: () => void;
    onRefine: (phrase: PhrasesSelectorPhrase) => void;
}

type StateProps = TStateProps<PhrasesSelectorRefinePhraseProps, OwnProps>;

type DispatchProps = TDispatchProps<PhrasesSelectorRefinePhraseProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const {
        refinements: {
            isPhraseShowsLoading,
            isPhrasesLoading,
            phrase,
            refineWords,
            hasMoreRefineWords,
            phraseShowsPrediction,
            phrasesError,
            phraseShowsError
        }
    } = selectPhrasesSelectorWizard(state, ownProps.wizardId);

    return {
        isPhraseShowsLoading,
        isPhrasesLoading,
        hasMoreRefineWords,
        refineWords,
        editPhrase: phrase,
        phraseWords: phrase.split(' '),
        phraseShowsPrediction,
        phrasesError,
        phraseShowsError
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { wizardId } = ownProps;

    return {
        onRefineWordsGet(phrase: string) {
            dispatch(phrasesSelectorGetRefineWords(wizardId, phrase));
        },
        onPhraseStatsGet(phrase: string) {
            dispatch(phrasesSelectorGetPhraseStats(wizardId, phrase));
        },
        onPhraseChange(phrase: string) {
            dispatch(phrasesSelectorChangeRefinePhrase(wizardId, phrase));
        },
        onPhraseInfoSet() {
            const { keyword, shows } = ownProps;

            dispatch(phrasesSelectorSetPhraseInfo(wizardId, keyword, shows));
        }
    };
};

export const PhrasesSelectorRefinementsContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(PhrasesSelectorRefinePhrase);
